import {
  List,
  Datagrid,
  TextField,
  TextInput,
  Filter,
  ArrayField,
  SingleFieldList,
  ChipField,
  DateField,
} from "react-admin";

import CustomActions from "../../../components/CustomActions";
import { ListPagination } from "../../../utils";
import { exporter } from "../utils";

const SurveyFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Ciclo" source="cycle.id" alwaysOn />
    <TextInput label="Pergunta" source="question" />
  </Filter>
);

const SurveyList = (props) => (
  <List
    hasCreate={true}
    perPage={25}
    title="Lista de Pesquisas"
    bulkActionButtons={<div />}
    exporter={exporter}
    actions={<CustomActions />}
    filters={<SurveyFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <ArrayField sortable={false} label="Ciclo" source="cycle">
        <SingleFieldList>
          <ChipField source="id" />
        </SingleFieldList>
      </ArrayField>
      <TextField label="Pergunta" source="question" />
      <ArrayField sortable={false} label="Respostas" source="options">
        <SingleFieldList>
          <ChipField source="value" />
        </SingleFieldList>
      </ArrayField>
      <ArrayField sortable={false} label="Respondido Por" source="answeredBy">
        <SingleFieldList>
          <ChipField source="user.document" />
        </SingleFieldList>
      </ArrayField>
      <DateField label="Data de Criação" source="createdAt" />
    </Datagrid>
  </List>
);

export default SurveyList;
